import { Particle, type ParticleOptions } from "../Particle";
import { MovesUp } from "../behaviors/MovesUp"; 
import { Lifetime } from "../behaviors/Lifetime";
import { SpawnsSmoke } from "../behaviors/SpawnsSmoke";
import { SpreadFire } from "../behaviors/SpreadFire";
import { adjustColor } from "../../utils/color";
import { Smoke } from "./Smoke";
import { Empty } from "./Empty";

export class Fire extends Particle {
    // 丰富的火焰颜色：深红 -> 橙红 -> 金黄 -> 白
    static colors = [
        0xA60000, // Deep Red
        0xFF2200, // Vibrant Red
        0xFF5500, // Neon Orange
        0xFF9900, // Bright Gold
        0xFFCC00, // Yellow
        0xFFFF33, // Pale Yellow
        0xFFFFFF  // White
    ];

    constructor(options: Partial<ParticleOptions> = {}) {
        // 随机选择基础颜色，模拟火焰内部的层次感
        // 偏向于选择中间的橙色/金黄色，两端的颜色概率稍低一点
        // 这里简单用均匀随机
        const baseColor = Fire.colors[Math.floor(Math.random() * Fire.colors.length)] ?? 0xFF5500;

        super({
            name: "Fire",
            color: adjustColor(baseColor, 10),
            behaviors: [
                new MovesUp(),
                new SpawnsSmoke(0.05), // 燃烧过程中的少量烟雾
                new SpreadFire(0.05), // 提高直接传播概率
                new Lifetime(8, 15, () => {
                    // 火焰熄灭时，有大概率变成烟雾继续上升
                    // 这会让火苗顶部有明显的烟雾拖尾效果
                    return Math.random() < 0.6 ? new Smoke() : new Empty();
                })
            ],
            temperature: 800,
            minTemp: 20,
            maxTemp: 2000,
            ...options
        });
    }
}
